export enum OrigenFuente {
    PERSONA = 1,
    ENTIDAD = 2,
    REL_USUARIO_ENTIDADES = 8,
    PORTAL_USUARIO = 9
}